import Cookies from "js-cookie";
import request from "@/utils/request";

export const kelimeyiOkunduYap = (kelimeId) => {
    return request({
        url: 'okunamayankelime/Kapat',
        params: {
            kelimeId
        }
    })
}

export const toplamSayi = () => {
    return request({
        url: 'okunamayankelime/ToplamSayi',
    })
};

export const okunamayanKelimeyiGetir = (id) => {
    return request({
        url: 'OkunamayanKelime/Getir',
        params: {
            id
        }
    })
};


export const okunamayanlariGetir = (filtreModu) => {
    return request({
        url: 'OkunamayanKelime/HepsiniGetir',
        params: {
            filtreModu,
            sondanBirMiktar:true
        }
    })
};

export function okunmayanKelimeEkle(tur, id, aciklama, kesmeDetaylari) {

    return request({
        method: 'post',
        url: 'OkunamayanKelime/ekle',
        params: {
            id,
            tur,
            aciklama,
            trueWidth: parseInt(kesmeDetaylari.trueWidth),
            trueHeight: parseInt(kesmeDetaylari.trueHeight),
            x: parseInt(kesmeDetaylari.x1),
            y: parseInt(kesmeDetaylari.y1),
            frameWidth: parseInt(kesmeDetaylari.framew),
            frameHeight: parseInt(kesmeDetaylari.frameh),
            scale: kesmeDetaylari.scale,
            angle: kesmeDetaylari.angle
        }
    })
}

export function okunmayanKMesajEkle( kelimeId, metin) {

    return request({
        method: 'post',
        url: 'OkunamayanKelime/mesajekle',
        params: {
            kelimeId,
            metin,
        }
    })
}
